import { addOppFieldsToCheckNonRequiredErrors } from '@user/components/Settings/EntityFormSettings'
import type {
  FieldSettingsMap,
  ICustomFieldFormSetting,
} from '@user/store/entityFormSettings'
import { IOpportunityPostModel } from '@user/store/opportunity'

export const useRemoveHiddenFieldsFromAPI = (
  entitySettingsMap: FieldSettingsMap,
  customFieldSettings: ICustomFieldFormSetting[],
) => {
  const removeHiddenFieldsFromAPI = (oppData: IOpportunityPostModel) => {
    const cleanedOppData = { ...oppData }

    addOppFieldsToCheckNonRequiredErrors.forEach((field) => {
      const [isRequired, hasEnabled] = entitySettingsMap.get(field.name) ?? [
        false,
        false,
      ]
      if (!isRequired && !hasEnabled) {
        field.errorFields.filter((errorField) => {
          delete cleanedOppData[errorField]
        })
      }
    })

    customFieldSettings.map((cs) => {
      if (!cs.required && !cs.enabled) {
        cleanedOppData.customFieldValues.map((customField) => {
          if (customField.customFieldId !== cs.customFieldId) return customField
        })
      }
    })

    return cleanedOppData
  }

  return { removeHiddenFieldsFromAPI }
}
